import Social from './Components/Social';
import Navbar from './Components/Navbar';


function App() {
  
  return (
    <div>
     <Navbar />
     <Social />
    </div>
  );
}

export default App;
